import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../contextApi/useAuth.js";
import { toast } from "react-hot-toast";
import Sidebar from "../Components/Sidebar.js";
import Header from "../Components/Header";
import FirebaseJwt from '@presswink/firebase-jwt';

const Dashboard = () => {
  const { isLoggedIn, isLoading, user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [hasChecked, setHasChecked] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const jwt = new FirebaseJwt("abcdefghijklmnoplqrst");
  const token = window.sessionStorage.getItem("token");

  useEffect(() => {
    if (!isLoggedIn) {
      sessionStorage.removeItem("token");
      console.log("Session token removed");
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (!isLoading && !hasChecked) {
      if (!isLoggedIn || !token) {
        toast.error("You must be logged in to access the dashboard.");
        navigate("/"); // Redirect to login
      } else {
        setHasChecked(true); // Mark the check as completed
      }
    }
  }, [isLoading, isLoggedIn, hasChecked, token, navigate]);

  if (isLoading || !hasChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-green-500 border-opacity-50"></div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <Sidebar user={user} onCourseSelect={setSelectedCourse} />
      <div className="main-content">
        <Header user={user} logout={logout} />
        <h1 className="text-center mt-8 text-xl font-semibold">
          Welcome to {user?.payload?.name}'s Dashboard
        </h1>
        <div className="card-container mt-8 mx-auto max-w-4xl bg-white rounded-lg shadow-lg p-6 ml-[28%]">
          {selectedCourse ? (
            <>
              <h2 className="text-2xl font-bold mb-4 text-center">
                {selectedCourse.course_name}
              </h2>
              <div className="video-section">
                {selectedCourse.video_urls ? (
                  selectedCourse.video_urls.split(",").map((url, index) => (
                    <div key={index} className="video-container mb-5">
                      {/* <video
                        src={url}
                        controls
                        className="w-full h-auto rounded-lg shadow-md"
                        alt={`Video ${index + 1}`}
                      /> */}
                      <iframe className="rounded-lg shadow-md" height="500"  width="740" src={`${url}?controls=1`}   allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"  title="Nepal Meeting (16-12-2024)"></iframe>
                    </div>
                  ))
                ) : (
                  <p className="text-center text-gray-500">
                    No videos available for this course
                  </p>
                )}
              </div>
            </>
          ) : (
            <p className="text-center text-gray-500">
              Select a course to view videos
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
